<template>
<div class="tab-content p-0 bg-light1" id="nav-tabContent">
    <div class="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">

        <div v-if="status" class="table-responsive table-responsive-sm">
            <table class="table table-striped table-sm text-nowrap1 table-bordered mb-0">
                <tbody>
                    <tr>
                        <th>Customer Name</th>
                        <td>{{basicDetail.customer?.customer_name}}</td>
                    </tr>
                    <tr>
                        <th>Container No.</th>
                        <td>{{basicDetail.container_no}}</td>
                    </tr>
                    <tr>
                        <th>Destination</th>
                        <td>{{basicDetail.destination}}</td>
                    </tr>
                    <tr>
                        <th>Plant</th>
                        <td>{{basicDetail.plant?.plant_name}}</td>
                    </tr>
                    <tr>
                        <th>Transporter</th>
                        <td>{{basicDetail.transporter?.transporter_name}}</td>
                    </tr>
                    <tr>
                        <th>Wagon No.</th>
                        <td>{{basicDetail?.wagon_no}}</td>
                    </tr>
                    <tr>
                        <th>Grade</th>
                        <td>{{basicDetail?.details?.grade}}</td>
                    </tr>
                    <tr>
                        <th>Lot No</th>
                        <td>{{basicDetail?.details?.lot_nos}}</td>
                    </tr>
                    <tr>
                        <th>Packing</th>
                        <td>{{basicDetail?.details?.packings}}</td>
                    </tr>
                    <tr>
                        <th>No of Bags Loaded</th>
                        <td>{{basicDetail?.details?.loading_bags}}</td>
                    </tr>
                    <tr>
                        <th>Loaded quantity</th>
                        <td>{{basicDetail?.details?.loading_quantity}}</td>
                    </tr>
                    <tr>
                        <th>Type of Loading</th>
                        <td>
                            <select class="form-control" :class="{ 'is-invalid': errors.loading_type_id }" v-model="basicDetail.loading_type_id" :disabled="loading_type_status" @change="generateTripStages()">
                                <option value="null">Select Loading Type</option>
                                <option v-for="loading_type, key in loading_types" :key=key :value="loading_type.loading_type_id">{{ loading_type.loading_type_name }}</option>
                            </select>
                            <span v-if="errors.loading_type_id"><small class="text-danger">{{ errors.loading_type_id[0] }}</small></span>
                        </td>
                        <!-- <td>{{basicDetail?.details?.loading_types}}</td> -->
                    </tr>
                    <!-- <tr>
                        <th>Pallet Weight and Pallet Sizes</th>
                        <td>
                            <a
                                href="javascript:void(0)"
                                class="text-success"
                                data-bs-toggle="modal"
                                data-bs-target="#palletDetailsModal"
                                @click.prevent="openPalletDetailsModal()"
                            >
                                <i class="ri-eye-line fs-18 lh-1"></i>
                            </a>
                        </td>
                    </tr> -->
                </tbody>
            </table>
            <br />
        </div>
        <div v-else class="">
            <table class="table table-striped table-sm text-nowrap1 table-bordered mb-0">
                <thead>
                    <tr class="bg-light1" style="background-color: #9b9b9b; color: white;">
                        <th>
                            Check Name
                        </th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>

                    <tr v-for="value, key in item" :key="key">
                        <td>{{ value.check_name }}</td>
                        <td>{{value.value }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="modal fade" id="palletDetailsModal" tabindex="-1" aria-labelledby="palletDetailsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="palletDetailsModalLabel">Pallet Weight and Pallet Sizes</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h6 class="mb-2">Slip Pallet Sizes</h6>
                    <div class="table-responsive table-responsive-sm mb-4">
                        <table class="table table-striped table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th>Slip No.</th>
                                    <th>No. of Pallets</th>
                                    <th>Actual Weight</th>
                                    <th>Average Weight</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="!modalSlipPalletSizes.length">
                                    <td colspan="4" class="text-center">No slip pallet sizes found</td>
                                </tr>
                                <tr v-for="(slipPalletSize, key) in modalSlipPalletSizes" :key="'sps-'+key">
                                    <td>{{ slipPalletSize.slip_no }}</td>
                                    <td>{{ slipPalletSize.no_of_pallets }}</td>
                                    <td>{{ slipPalletSize.actual_weight }}</td>
                                    <td>{{ slipPalletSize.average_weight }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h6 class="mb-2">Pallet Weights</h6>
                    <div class="table-responsive table-responsive-sm mb-3">
                        <table class="table table-striped table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th>Slip No.</th>
                                    <th>Empty Pallet Weight</th>
                                    <th>Gross Weight</th>
                                    <th>No. of Bags Per Pallet</th>
                                    <th>Checked By</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="!modalPalletWeights.length">
                                    <td colspan="7" class="text-center">No pallet weights found</td>
                                </tr>
                                <tr v-for="(palletWeight, key) in modalPalletWeights" :key="'pw-'+key">
                                    <td>{{ palletWeight.slip_no }}</td>
                                    <td>{{ palletWeight.empty_pallet_weight }}</td>
                                    <td>{{ palletWeight.gross_weight }}</td>
                                    <td>{{ palletWeight.no_of_bags_per_pallet }}</td>
                                    <td>{{ palletWeight.checked_by || '-' }}</td>
                                    <td>{{ palletWeight.remarks || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "TripChecks",
    props: {
        item: Array,
        basicDetail: Object,
        status: Boolean,
        trip_attachments: Array,
        loading_type_status:Boolean
    },
    data() {
        return {
            trip_check_attachments: [],
            check_name: '',
            tripCheck: {},
            checkAttachmentStatus: false,
            loading_types:[],
            errors:[],
            // loading_type_status:false,
            trip_stages:[],
            modalPalletWeights: [],
            modalSlipPalletSizes: [],
        }
    },

    mounted() {
        this.trip_check_attachments = []
        this.getLoadingTypes()
    },
    methods: {
        show(trip_check) {
            // this.checkAttachmentStatus=true;
            this.checkAttachmentStatus = true
            //console.log("trip_check----------", trip_check);
            this.tripCheck = trip_check
            this.trip_check_attachments = trip_check.trip_attachments
            this.check_name = trip_check.check_name
        },
        getLoadingTypes() {
            let vm = this;
            vm.$store
                .dispatch("post", { uri: "getLoadingTypes" })
                .then((response) => {
                    vm.loading_types = response.data.data
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        generateTripStages(){
            let vm = this;
            vm.$store
                .dispatch("post", { uri: "generateTripStages", data:vm.basicDetail })
                .then((response) => {
                    vm.trip_stages = response.data.data
                    vm.$emit('tripStages', vm.trip_stages)
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        openPalletDetailsModal() {
            let slips = this.basicDetail?.slips || [];
            this.modalPalletWeights = [];
            this.modalSlipPalletSizes = [];

            slips.forEach((slip) => {
                const slipNo = slip?.slip_no || "-";
                (slip?.pallet_weights || []).forEach((palletWeight) => {
                    this.modalPalletWeights.push({
                        ...palletWeight,
                        slip_no: slipNo,
                    });
                });
                (slip?.slip_pallet_sizes || []).forEach((slipPalletSize) => {
                    this.modalSlipPalletSizes.push({
                        ...slipPalletSize,
                        slip_no: slipNo,
                    });
                });
            });
        }
    },
};
</script>
